<a routerLink="DoveSiamo">
<div class="container-fluid" id="boxl">
  <div class="row" id="rigal">
    Dove siamo
  </div>
</div>
</a>